'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var Config = require('config')

var App = require('app')
var _ = require('lodash')
var PageModel = require('src/common/page-model')

var DevicesFilter = require('src/components/devices-filter')
var DeviceTypes = require('src/common/app-constants').deviceTypes

var View = require('./view.js')
// var Search = require('./search.js')
var Moment = require('moment')

var List = function () {
  var Controller = Marionette.Object.extend({
    initialize: function () {
      var self = this

      var pageModel = new PageModel({
        title: 'Reports',
        buttons: [],
        tabs: []
      })

      var FilterQueryModel = Backbone.Model.extend({
        defaults: {
          query: {}
        }
      })
      self.filterQueryModel = new FilterQueryModel({})
      //
      self.devicesCollection = App.globalChannel.request('device:entities', { pagination: false, query: {'$limit': 10000} })

      var pageModel = new PageModel({
        title: 'Reports'
      })

      self.layout = self.getLayoutView(pageModel)

      self.listenTo(self.layout, 'render', _.bind(self.filterRegion, self))
      self.listenTo(self.layout, 'render', _.bind(self.bodyRegion, self))

      App.rootLayout.showChildView('mainRegion', self.layout)
    },
    bodyRegion: function () {
      var self = this
      self.bodyLayout = self.getReportsView(self.devicesCollection)
      self.listenTo(self.bodyLayout, 'render', function () {
        self.showReportsData()
        self.showReports()
      })

      // self.listenTo(bodyLayout, 'childview:client:edit', _.bind(self.onEdit, self))
      // self.listenTo(bodyLayout, 'childview:client:show', _.bind(self.onShow, self))

      self.layout.showChildView('bodyRegion', self.bodyLayout)
    },
    showReportsData: function (region) {
      var ReportListModel = Backbone.Model.extend({})
      this.reportListModel = new ReportListModel({
        startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD'),
        endDate: Moment().subtract(1, 'day').format('YYYY-MM-DD'),
        resolution: 'day'
      })
      var reportsDataView = this.getReportsDataView(this.reportListModel)

      // listen wheter to refresh the report
      this.listenTo(reportsDataView, 'report:refresh', this.onShowReport)
      this.listenTo(reportsDataView, 'report:export', this.onDownloadReport)

      this.bodyLayout.showChildView('reportsDataRegion', reportsDataView)
    },
    showReports: function (region) {
      var self = this
      var debouncedShowReport = _.debounce(_.bind(self.onShowReport, self), 250, {'trailing': true})

      // setup a collection which holds the reports labels
      var ReportListModel = Backbone.Model.extend({
        defaults: {
          active: false
        }
      })
      var ReportListCollection = Backbone.Collection.extend({

        model: ReportListModel,
        // activates a model and deActivates all other models
        setActive: function (id) {
          // deactivate all models
          this.each(function (model) { if (model) model.set('active', false) })
          var model = this.get(id)
          if (model) model.set('active', true)
        }
      })

      var reportCollection = new ReportListCollection([
        {id: 'pri_current', label: 'Primary Current', sensor: 'pri_current', title: 'Primary current overview (mA)'},
        {id: 'sec_current', label: 'Secondary Current', sensor: 'sec_current', title: 'Secondary current overview (mA)'},
        {id: 'pri_voltage', label: 'Primary Voltage', sensor: 'pri_voltage', title: 'Primary voltage overview'},
        {id: 'sec_voltage', label: 'Secondary Voltage', sensor: 'sec_voltage', title: 'Secondary voltage overview'},
        {id: 'co2', label: 'CO2', sensor: 'co2', title: 'CO2'},
        {id: 'signal_quality_rssi', label: 'Rssi', sensor: 'signal_quality_rssi', title: 'Rssi'}
      ])

      // assign the first report to be shown
      var firstReport = reportCollection.get('pri_current')

      self.listenTo(self.reportListModel, 'change', function (model) {
        reportCollection.setActive(model.get('sensor'))
      })

      self.reportListModel.set('title', firstReport.get('title'))
      self.reportListModel.set('sensor', firstReport.get('sensor'))
      self.onShowReport({model: self.reportListModel})

      var reportsListView = this.getReportsListView(reportCollection)
      // this.listenTo(reportsListView, 'report:export', function (args) {
      //   console.log(args)
      // })

      reportsListView.on('childview:report:show', function (args) {
        self.reportListModel.set('title', args.model.get('title'))

        self.reportListModel.set('sensor', args.model.get('sensor'))
        self.onShowReport({model: self.reportListModel})
      })
      this.bodyLayout.showChildView('reportsListRegion', reportsListView)

      self.devicesCollection.on('sync add remove', function () {
        // debouncedShowReport({model: self.reportListModel})
      })

      self.listenTo(self.filterQueryModel, 'change', function () {
        debouncedShowReport({model: self.reportListModel})
      })
    },
    helpers: {
      parseJsonAsQueryString: function (obj, prefix) {
        var str = [], p
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + '[' + p + ']' : p, v = obj[p]
            str.push((v !== null && typeof v === 'object') ?
              parseJsonAsQueryString(v, k) :
              encodeURIComponent(k) + '=' + encodeURIComponent(v))
          }
        }
        return str.join('&')
      }
    },
    onDownloadReport: function (args) {
      var self = this

      var startDate = args.model.get('startDate')
      var endDate = args.model.get('endDate')

      var data = _.extend({
        'startDate': startDate,
        'endDate': Moment(endDate).add(1, 'days').format('YYYY-MM-DD'),
        'sensor': args.model.get('sensor'),
        'resolution': args.model.get('resolution'),
        'timeoffset':Moment().format('ZZ')
      }, self.filterQueryModel.get('query'))

      //

      var reportModel = App.globalChannel.request('statistics:entity', {})
      reportModel.download(data)
    },
    onShowReport: function (args) {
      var self = this

      var startDate = args.model.get('startDate')
      var endDate = args.model.get('endDate')

      var data = _.extend({
        'startDate': startDate,
        'endDate': Moment(endDate).add(1, 'days').format('YYYY-MM-DD'),
        'sensor': args.model.get('sensor'),
        'resolution': args.model.get('resolution')
      }, self.filterQueryModel.get('query'))

      //
      var reportModel = App.globalChannel.request('statistics:entity', {})
      reportModel.fetch({data: data})

      this.listenTo(reportModel, 'sync', function (model) {
        self.reportListModel.set('data', model.attributes)
      })
    },
    //
    /* Regions --------------------------------------------------------------- */
    filterRegion: function () {
      var FilterSourceModel = Backbone.Model.extend({})
      var FilterSourceCollection = Backbone.Collection.extend({ model: FilterSourceModel })

      //
      var clientsFilterSource = App.globalChannel.request('client:entities', {query: {$select: 'name', $limit: 100}})

      var typeFilterSource = new FilterSourceCollection(_.map(DeviceTypes, (item) => {
        return {name: item.label, value: item.id}
      }))

      var stateFilterSource = new FilterSourceCollection([
        {name: 'online', value: 'online'},
        {name: 'offline', value: 'offline'},
        {name: 'error', value: 'error'}
      ])

      //
      var devicesFilter = new DevicesFilter(
        {
          region: this.layout.getRegion('filterRegion'),
          title: 'Report generator',
          filterCache: App.devicesFilterCache, // link to an persisted object to store the selected filters etc
          filters: [
            {
              id: 'client', // unique filter id
              domain: 'client', // key which indicates the subject of thedata and correspondents to the database
              name: 'client', // visual
              label: 'client', // visual
              lingualSubject: 'by',
              prependedText: 'by client',
              type: 'multi_select',
              collection: clientsFilterSource,
              collectionMap: {label: 'name', value: '_id'},
              role: ['super', 'admin']
            },
            {
              id: 'type',
              domain: 'type',
              name: 'type',
              label: 'device type',
              lingualSubject: 'by',
              prependedText: 'by type',
              type: 'multi_select',
              collection: typeFilterSource,
              collectionMap: {label: 'name', value: 'value'}, // might be better to be able to ignore the collectionMap
              role: []
            },
            {
              id: 'state', // unique filter id
              domain: 'state', // key which indicates the subject of thedata and correspondents to the database
              name: 'state', // visual
              label: 'device state', // visual
              lingualSubject: 'by',
              prependedText: 'which state is',
              type: 'select',
              collection: stateFilterSource,
              collectionMap: {label: 'name', value: 'value'},
              role: []
            },
            {
              id: 'location', // unique filter id
              domain: 'location', // key which indicates the subject of thedata and correspondents to the database
              name: 'location', // visual
              label: 'device location', // visual
              lingualSubject: 'where',
              prependedText: 'located near',
              type: 'location',
              role: [],
              value: {
                location: [51.6878954, 5.0574822],
                radius: 1000
              }
            },
            {
              id: 'name',
              domain: 'name',
              name: 'name',
              label: 'name',
              lingualSubject: 'contains',
              prependedText: 'by name',
              type: 'text',
              role: []
            }
          ]
        })

      devicesFilter.on('queryUpdate', function (result) {
        // build query
        var query = {}

        _.forEach(result, function (value, filterName) {
          switch (filterName) {
            case 'name':
              query[filterName] = '{contain}' + value
              break
            default:
              if (value.length > 0) {
                query[filterName] = value.join(',')
              }
              break
          }
          //      console.log(result)
        })

        // console.log(query)
        query['$limit'] = 10000
        // console.log(result)
        self.devicesCollection.fetch({reset: true, data: query})
      // self.groupsCollection.fetch({reset: true,data: query})
        self.filterQueryModel.set('query', query)
      })

      // -
      var self = this
    },
    /* Views ----------------------------------------------------------------- */
    getReportsDataView: function (model) {
      return new View.ReportsDataLayout({model: model})
    },
    getReportsListView: function (collection) {
      return new View.ReportsListView({collection: collection})
    },
    getReportsView: function (collection) {
      return new View.Reports({collection: collection})
    },
    getLayoutView: function (pageModel, model) {
      return new View.Layout({pageModel: pageModel, model: model})
    }
    // getLayoutView: function (pageM) {
    //   return new View.Layout({collection: collection})
    // }
  })

  return new Controller()
}

module.exports = List



// WEBPACK FOOTER //
// ./js/modules/page-reports/list/index.js